import script from "./VoucherButton.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherButton.vue?vue&type=script&setup=true&lang=js"

import "./VoucherButton.vue?vue&type=style&index=0&id=a60eed6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a60eed6e"]])

export default __exports__